var _path, _path2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavePdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "save-pdf",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5H11.5L17 6V12H15V7H11V3H3V18H8V20H3C1.9 20 1 19.1 1 18V2.5C1 1.4 1.9 0.5 3 0.5ZM13 3.4V5H14.6L13 3.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13H20C20.55 13 21 13.45 21 14V20.5C21 21.05 20.55 21.5 20 21.5H8C7.45 21.5 7 21.05 7 20.5V14C7 13.45 7.45 13 8 13Z",
    fill: "#DC2626"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 19.5,
    fontFamily: "Arial, sans-serif",
    fontSize: 6.5,
    fontWeight: 900,
    fill: "white",
    textAnchor: "middle"
  }, "PDF")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavePdf);
export default __webpack_public_path__ + "static/media/save-pdf.fb1814e560a2c592560426c60bf70ecc.svg";
export { ForwardRef as ReactComponent };